import { render, staticRenderFns } from "./SidebarNavLabelIS.vue?vue&type=template&id=37d96dd8"
import script from "./SidebarNavLabelIS.vue?vue&type=script&lang=js"
export * from "./SidebarNavLabelIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports